import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDpad = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M40.072 5A5.06 5.06 0 0 0 35 10.072V35H10.072a5.06 5.06 0 0 0-5.073 5.073v19.855A5.06 5.06 0 0 0 10.072 65H35v24.928A5.06 5.06 0 0 0 40.072 95h19.855a5.06 5.06 0 0 0 5.072-5.072V65h24.928A5.06 5.06 0 0 0 95 59.928V40.073A5.06 5.06 0 0 0 89.927 35H65V10.072A5.06 5.06 0 0 0 59.927 5z" })
});
export default SvgDpad;
